import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ADPResourceService} from 'digital-core';

@Component({
  selector: 'pgh-document',
  templateUrl: './document.component.html',
  styles: ['iframe { border: none; }']
})
export class DocumentComponent implements OnInit {
  documentNotFound = false;
  constructor(
    private resourceService: ADPResourceService,
    public activatedRoute: ActivatedRoute,
    public router: Router
  ) {}

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(params => {
      var filename = this.activatedRoute.snapshot.paramMap.get('filename');
      var setting  = this.resourceService.getPortalSetting('URL_Doc_'+filename.toLowerCase());
      if(setting) {
        window.document.location = setting.Value;
      } else  {
        this.documentNotFound  = true;
      }
    });


  }

}
